import { render, staticRenderFns } from "./ShibouDoukishoEdit.vue?vue&type=template&id=0b3a8e76&scoped=true"
import script from "./ShibouDoukishoEdit.vue?vue&type=script&lang=js"
export * from "./ShibouDoukishoEdit.vue?vue&type=script&lang=js"
import style0 from "./ShibouDoukishoEdit.vue?vue&type=style&index=0&id=0b3a8e76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3a8e76",
  null
  
)

export default component.exports